import { graphql } from '@/gql';
import type { PlansQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchPlans = async (variables: PlansQueryVariables = {}) => {
  const response = await queryExecute({
    query: graphql(`
      query Plans($kind: PlanKind, $name: String, $pagination: PaginationInputType) {
        plans(kind: $kind, name: $name, pagination: $pagination) {
          count
          rows {
            id
            name
            kind
            amount
            isActive
            hasTrial
            trialPrice
            tier
            isDefault
            fragmentInto
            defragmentInto
            upgradeInto
          }
        }
      }
    `),
    variables,
    fetchPolicy: 'no-cache',
  });

  if (!response.data.plans) {
    throw new Error('Failed to fetch plans');
  }

  return response.data.plans;
};
